import { Button } from "@/v2-components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/v2-components/ui/dialog";
import React from "react";
import { LanguageCode } from "@/utils/LocaleUtil";

interface DialogTexts {
  header: string;
  desc1: string;
  desc2: string;
  btn1: string;
  btn2: string;
}

const TRANSLATIONS: Record<LanguageCode, DialogTexts> = {
  en: {
    header: "Confirm Shipping Country",
    desc1: "Shipping country differs from your current location.",
    desc2: "Do you want to continue with this country?",
    btn1: "Change Country",
    btn2: "Confirm",
  },
  ko: {
    header: "배송 국가 확인",
    desc1: "배송 국가가 현재 위치와 다릅니다.",
    desc2: "이 국가로 계속 진행하시겠습니까?",
    btn1: "국가 변경",
    btn2: "확인",
  },
  ja: {
    header: "配送先の国を確認",
    desc1: "配送先の国が現在の場所と異なります。",
    desc2: "この国で続行しますか？",
    btn1: "国を変更",
    btn2: "確認",
  },
  zh: {
    header: "确认送货国家",
    desc1: "送货国家与您当前的位置不同。",
    desc2: "您想继续使用此国家吗？",
    btn1: "更改国家",
    btn2: "确认",
  },
  fr: {
    header: "Confirmer le pays de livraison",
    desc1: "Le pays de livraison diffère de votre emplacement actuel.",
    desc2: "Voulez-vous continuer avec ce pays ?",
    btn1: "Changer de pays",
    btn2: "Confirmer",
  },
  de: {
    header: "Lieferland bestätigen",
    desc1: "Das Lieferland unterscheidet sich von Ihrem aktuellen Standort.",
    desc2: "Möchten Sie mit diesem Land fortfahren?",
    btn1: "Land ändern",
    btn2: "Bestätigen",
  },
  es: {
    header: "Confirmar país de envío",
    desc1: "El país de envío difiere de su ubicación actual.",
    desc2: "¿Desea continuar con este país?",
    btn1: "Cambiar país",
    btn2: "Confirmar",
  },
};

export default function ConfirmCountry({
  languageCode,
  onCancel,
  onConfirm,
  onClose,
}: {
  languageCode: LanguageCode;
  onClose: (e?: any) => void;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const T = TRANSLATIONS[languageCode] ?? TRANSLATIONS.en;

  return (
    <Dialog open={true}>
      <DialogContent className="z-[100] flex max-h-[416px] max-w-[520px] flex-col p-8">
        <DialogHeader className="flex items-start">
          <DialogTitle className="text-lg font-500">{T.header}</DialogTitle>
          <div onClick={onClose} className="w-8.5 cursor-pointer">
            <DialogClose className="size-6" />
          </div>
        </DialogHeader>
        <DialogDescription
          className="flex-1 text-base font-400 text-coolgray-90"
          asChild
        >
          <div>
            <p>{T.desc1}</p>
            <p className="mt-4">{T.desc2}</p>
          </div>
        </DialogDescription>
        <DialogFooter className="flex flex-wrap items-center justify-end gap-2">
          <Button
            onClick={onCancel}
            variant="blue-outline"
            shape="pill"
            size="sm"
            className="!px-6"
          >
            {T.btn1}
          </Button>
          <Button
            onClick={onConfirm}
            variant="blue-fill"
            shape="pill"
            size="sm"
            className="!px-6"
          >
            {T.btn2}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
